module.exports = __webpack_public_path__ + "ed4771cecd08af5ea4b5b46f626121d7.png";